import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Sticky {
  constructor(el) {
 
    this.el = el;
    
    this.sticky = this.el;
    this.stickyHeight = 0;
    this.hiddenTop = 0;
		this.limit = 0;
    this.state = false;
    this.lastDirection = false;
    this.resizeRaf = null;

    this.computeMetrics();
    this.init();
    this.bindEvents();
  }

  computeMetrics() {
    const rect = this.el.getBoundingClientRect();
    this.stickyHeight = rect.height;
    this.hiddenTop = this.stickyHeight * -1 - 6;
    this.limit = rect.top + rect.height + window.scrollY + 100;
  }

  bindEvents() {
    window.addEventListener("resize", () => {
      if (this.resizeRaf) return;
      this.resizeRaf = requestAnimationFrame(() => {
        this.resizeRaf = null;
        this.computeMetrics();
        ScrollTrigger.refresh();
      });
    });
  }

  init() {
 
    ScrollTrigger.create({
      start: "top top",
      end: "bottom top",
      onRefreshInit: () => this.computeMetrics(),
      onUpdate: (self) => {
        const y = window.scrollY;
         
        if ( y > this.limit && y < 400) {

          if( this.state !== 'ready' ){  
            gsap.set(this.sticky, { position: "fixed", top: this.hiddenTop });
            this.state = "ready";
          }

        } else if (y > 400) {

          
          if( this.state !== 'sticky' ){  
            gsap.set(this.sticky, { position: "fixed", top: this.hiddenTop }); 
            this.sticky.classList.add("is-sticky");
            document.body.classList.add("is-sticky"); 
            this.state = "sticky";
          }
          
          if( this.lastDirection !== self.direction ){
            if (self.direction === -1) { 
              gsap.set(this.sticky, { top: 0 });
            } else { 
              gsap.set(this.sticky, { top: this.hiddenTop });
            } 
          }

        } else {

          if( this.state !== 'initial' ){   
            gsap.set(this.sticky, { position: "absolute", top: 0 }); 
            this.sticky.classList.remove("is-sticky"); 
            document.body.classList.remove("is-sticky");
            this.state = "initial";
          } 

        } 
        
        if( this.lastDirection !== self.direction ){
          this.setDirection(self.direction);
        }

      },
    });
  }

  setDirection(direction) {
    document.body.classList.remove("is-scroll-down");
    document.body.classList.remove("is-scroll-up"); 
    if (direction === -1) { 
      document.body.classList.add("is-scroll-up"); 
    } else {
      document.body.classList.add("is-scroll-down"); 
    }

		this.lastDirection = direction;
  }
}
